import React, { Component } from 'react';
import { ToggleSmall, Modal, Checkbox } from 'carbon-components-react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Breadcrumb, Card, Notification } from '../../../../components';
import unitsOfMensurements from '../../../../fixtures/unitsOfmeasurement';
import {
  insertDmService,
  getByDmService,
  updateDmService,
  deleteDmService,
  getDmService,
} from '../../../../services/Api';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      name: '',
      openMdDelete: false,
      listGroups: [],
      selectedItemType: null,
      listSizes: unitsOfMensurements,
      selectedItemSize: null,
      valueHeight: '',
      valueLarge: '',
      requiredValueLarge: true,
      requiredValueHeight: true,
      tamanhoFixo:false
    };
  }

  componentWillMount = async () => {
    await this.getGroups();
    await this.getItem();
  };

  getUnitMensured = idSize => {
    const { listSizes } = this.state;
    const selecionado = listSizes.filter(value => parseInt(value.id, 10) === idSize);
    return selecionado[0];
  };

  getItem = async () => {
    const { match } = this.props;
    const { selectedItemType } = this.state;
    const urlId = match.params && match.params.id;
    if (urlId) {
      const result = await getByDmService('/Tamanho', urlId);

      const { ativo, altura, grupo, largura, nome, unidadeMedida, isAlturaVariavel, isLarguraVariavel, tamanhoFixo } = result;
      const unitSelected = this.getUnitMensured(unidadeMedida);
      const idGrupo = grupo ? { id: grupo.id, label: grupo.nome } : selectedItemType.id;
      this.setState({
        active: ativo,
        name: nome,
        valueHeight: altura === 0 ? "" : altura,
        valueLarge: largura === 0 ? "" : largura,
        selectedItemSize: unitSelected,
        selectedItemType: idGrupo,
        requiredValueHeight: isAlturaVariavel,
        requiredValueLarge: isLarguraVariavel,
        tamanhoFixo
      });
    }
  };

  getGroups = async () => {
    const groups = await getDmService('/ProdutoCategoria/GetByTipo/?tipo=1');
    const groupsSelects = groups.map(value => ({ id: value.id, label: value.nome }));
    this.setState({
      listGroups: groupsSelects,
    });
  };

  onToogle = () => {
    const { match } = this.props;
    const { active } = this.state;
    // const urlId = match.params && match.params.id;
    // const selectedGrupo = {Id: selectedItemType.id}
    this.setState(
      prevState => ({
        active: !prevState.active,
      }),
      async () => {
        try {
          await updateDmService('Tamanho/AlteraStatus', match.params.id, null);
        } catch (e) {
          this.setState({ active });
          toast.warn('Ocorreu uma falha ao tentar trocar o status do item');
        }
      },
    );
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeNumber =  event => {  
    const val = event.target.value;
    const teste = val.split("")[0] === "." || val  === ".";

    if(!teste && (parseFloat(val, 10) === 0 || parseFloat(val, 10) >= 1) ){
      this.setState({ [event.target.name]: parseFloat(event.target.value, 10) });
    }else{
      this.setState({ [event.target.name]: "" });
    }
  }

  onChangeGroup = event => {
    this.setState({
      selectedItemType: { id: event.id, label: event.label },
    });
  };

  onChangeSize = event => {
    this.setState({
      selectedItemSize: { id: event.id, label: event.label },
    });
  };

  saveDetails = async e => {
    e.preventDefault();
    const { 
      name,
      valueLarge,
      valueHeight,
      selectedItemType,
      selectedItemSize,
      requiredValueLarge,
      requiredValueHeight,
      tamanhoFixo 
    } = this.state;

    const { match, history } = this.props;
    const urlId = match.params && match.params.id;
    const urlEdit = `/Tamanho/`;
    

    let newValueLarge = 0;    
    if(valueLarge && typeof valueLarge !== "number"){      
       newValueLarge = valueLarge.replace(",", ".");
    }else{
      newValueLarge = valueLarge
    }
    let newValueHeigth = 0
    if(valueHeight && typeof valueHeight !== "number"){
      newValueHeigth = valueHeight.replace(",", ".");
    }else{
      newValueHeigth = valueHeight
    }
    


    const formData = {
      grupo: { Id: selectedItemType.id },
      nome: name,
      UnidadeMedida: selectedItemSize.id,
      largura: newValueLarge || 0,
      altura: newValueHeigth || 0,
      isLarguraVariavel: requiredValueLarge,
      isAlturaVariavel: requiredValueHeight,
      tamanhoFixo
    };

    try {
      if (urlId) {
        await updateDmService(urlEdit, urlId, formData);
        history.goBack();
        toast.success('Edição realizada com sucesso.');
      } else {
        await insertDmService(urlEdit, formData);
        history.goBack();
        toast.success('Nome salvo com sucesso.');
      }
    } catch (error) {
      toast.warn('Desculpe-nos. Ocorreu alguma falha ao tentar salvar os dados');
    }
  };

  modalDelete = () => {
    this.setState(prevState => ({
      openMdDelete: !prevState.openMdDelete,
    }));
  };

  delete = async () => {
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;

    try {
      await deleteDmService('/Tamanho', urlId);
      toast.success('Deletado conforme o solicitado.');
      history.goBack();
    } catch (error) {
      toast.error('Um erro inesperado ocorreu ao tentar deletar');
    }
  };

  render() {
    const {
      active,
      name,
      valueHeight,
      valueLarge,
      openMdDelete,
      listGroups,
      selectedItemType,
      listSizes,
      selectedItemSize,
      requiredValueHeight,
      requiredValueLarge,
      tamanhoFixo,
    } = this.state;

    const { history, match } = this.props;
    const urlId = match.params && match.params.id;

    return (
      <div>
        {urlId ? (
          <Breadcrumb
            title="Editar tamanho"
            description="Gerencie tamanho de produtos agência."
            renderRight={(() => (
              <div className="flex v-sm-margin">
                <label
                  htmlFor="toogle-active"
                  className={`${active ? 'text-info ' : 'text-warning'} label-toogle-active`}
                >
                  {active ? 'Ativo' : 'Inativo'}
                </label>
                <ToggleSmall
                  id="toogle-active"
                  className="toogle-active"
                  toggled={active}
                  ariaLabel="Ativo"
                  onClick={() => this.onToogle()}
                />
                <button
                  className="bx--btn btn-primary-outlined h-sm-margin"
                  type="button"
                  onClick={() => this.modalDelete()}
                >
                  Remover
                </button>
              </div>
            ))()}
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        ) : (
          <Breadcrumb
            title="Criar tamanho"
            description="Gerencie tamanho de produtos agência."
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        )}

        <Card className="center-box">
          <form onSubmit={this.saveDetails}>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Grupo</label>
                <Select
                  className="search-dm"
                  name="grupos"
                  options={listGroups}
                  required
                  value={selectedItemType}
                  onChange={e => this.onChangeGroup(e)}
                  placeholder="Selecione o grupo"
                  isClearable={false}
                  isSearchable
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">Nome do tamanho</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="Digite aqui o nome do produto"
                  name="name"
                  value={name}
                  onChange={this.onChangeText}
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Unidade de medida</label>
                <Select
                  className="search-dm"
                  name="sizes"
                  options={listSizes}
                  required
                  value={selectedItemSize}
                  onChange={e => this.onChangeSize(e)}
                  placeholder="Selecione a unidade de medida"
                  isClearable={false}
                  isSearchable
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-12 v-md-margin">
                <Checkbox
                  id="requiredLarge"
                  className="check-form-sizes"
                  labelText={(
                    <span>
                      Este tamanho será usado em produtos que 
                      <strong> não calculam preço e não tem tamanho personalizado </strong>
                       pelo solicitante
                    </span>
                  )}
                  checked={tamanhoFixo}
                  onChange={value => {
                    this.setState({ tamanhoFixo: value });
                  }}
                />
              </div>
            </div>
            {!tamanhoFixo && (
              <div className="bx--row mg-left-20">
                <div className="bx--col-xs-12 bx--col-md-9 v-md-margin">
                  <Notification
                    kind="warning"
                    title="Atenção"
                    description={(
                      <p>
                        Marque o flag apenas em produtos que deverão 
                        <strong> calcular o preço </strong> 
                        e/ou em que o solicitante vá precisar entrar com o tamanho, ou seja
                        <strong> tamanho personalizado </strong>
                        <br />
                        <br />
                        <strong>Marcando o flag não e preenchendo</strong>
                        , o solicitante será obrigado a preencher
                        <br />
                        <br />
                        <strong>Marcando o flag e preenchendo</strong>
                        , o valor será usado junto a 
                        <strong> Medida </strong>
                        para cálculo de preços (esse número não é visto pelo solicitante, ele vê apenas o "nome do tamanho")
                      </p>
                    )}
                  />
                </div>
              </div>
            )}
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin ">Largura</label>
                <div className="bx--row">
                  <div className="bx--col-xs-1 bx--col-md-1">
                    <Checkbox
                      id="tamanhoFixo"
                      className="check-form-sizes"
                      labelText=""
                      disabled={tamanhoFixo}
                      checked={requiredValueLarge}
                      onChange={value => {
                        this.setState({ requiredValueLarge: value });
                      }}
                    />
                  </div>
                  <div className="bx--col-xs-10 bx--col-md-10 ">
                    <input
                      type="number"
                      className="bx--text-input f-right"
                      placeholder="Digite aqui o nome do produto"
                      name="valueLarge"
                      disabled={tamanhoFixo}
                      value={valueLarge}
                      onChange={this.onChangeNumber}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin ">Altura</label>
                <div className="bx--row">
                  <div className="bx--col-xs-1 bx--col-md-1">
                    <Checkbox
                      id="requiredHeight"
                      className="check-form-sizes"
                      labelText=""
                      disabled={tamanhoFixo}
                      checked={requiredValueHeight}
                      onChange={value => {
                        this.setState({ requiredValueHeight: value });
                      }}
                    />
                  </div>
                  <div className="bx--col-xs-10 bx--col-md-10 ">
                    <input
                      type="number"
                      className="bx--text-input f-right"
                      placeholder="Digite aqui o nome do produto"
                      name="valueHeight"
                      value={valueHeight}
                      disabled={tamanhoFixo}
                      onChange={this.onChangeNumber}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="bx--row mg-left-20 ">
              <div className="bx--col-xs-12 v-md-margin ">
                <button tabIndex="0" className="bx--btn btn-secondary-color" type="submit">
                  Salvar
                </button>
                <button
                  tabIndex="0"
                  className="h-sm-margin bx--btn btn-secondary-outlined"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </Card>

        <Modal
          className="some-class"
          open={openMdDelete}
          modalHeading="Remover Item"
          primaryButtonText="Tenho certeza"
          secondaryButtonText="Cancelar"
          iconDescription="Cancelar e fechar"
          onRequestClose={() => this.modalDelete()}
          onRequestSubmit={() => this.delete()}
        >
          <p className="bx--modal-content__text">Você tem certeza que deseja deletar este item?</p>
        </Modal>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/ManageSizes/Edit.js